import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// import registerServiceWorker from './registerServiceWorker';

import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import { setCurrentUser } from "./actions/auth.js";
import Listeners from "./helpers/listeners.js";

// Import the reducer and create a store
import rootReducer from "./reducers/rootReducer.js";

// Creare store
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
	rootReducer,
	compose(
		composeEnhancers(applyMiddleware(thunk))
		// window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	)
);

// store.subscribe(() => console.log("%cstore", "color: red", store.getState()));

if (localStorage.getItem("user")) {
	store.dispatch(setCurrentUser(JSON.parse(localStorage.getItem("user"))));
}

new Listeners(store);

// Import the App container
ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById("root")
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js